import { ComponentPropsWithoutRef } from 'react';
import styled from '@emotion/styled';
import { Responsive } from '../../utils';
import { ITheme, themed } from '../../themer';

export interface IColumnLayoutProps {
	columns?: Responsive.IValueOrResponsiveValue<number>;
}

const StyledColumnLayout = styled.div<IColumnLayoutProps, ITheme>`
	${Responsive.getStyles('columns', (value) => `column-count: ${value};`)};
	column-gap: ${themed(({ grid }) => grid.gutter.horizontal.default)};
`;

const DEFAULT_COLUMNS: Responsive.IValueOrResponsiveValue<number> = [
	2,
	{ mobileXL: 1 },
];

export function ColumnLayout({
	columns = DEFAULT_COLUMNS,
	...rest
}: ComponentPropsWithoutRef<typeof StyledColumnLayout>) {
	return <StyledColumnLayout columns={columns} {...rest} />;
}
